import {
  SessionStorageServiceImpl,
  USER_INITIALIZED_STORAGE_KEY,
} from '../shared/storage';

export class UserInitializedStorageService {
  private storageService: SessionStorageServiceImpl<string> =
    new SessionStorageServiceImpl();

  public get() {
    return this.storageService.getItem(USER_INITIALIZED_STORAGE_KEY) || 'false';
  }

  public markAsInitialized() {
    this.save(true);
  }

  public markAsNotInitialized() {
    this.save(false);
  }

  private save(userInitialized: boolean) {
    return this.storageService.setItem(
      USER_INITIALIZED_STORAGE_KEY,
      userInitialized.toString()
    );
  }
}
